import { lazy, Suspense, useEffect } from "react";
import { AppShell } from "./components/AppShell";
import { useLocation, useNavigate } from "./lib/router";

const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const ReplayArchivePage = lazy(() => import("./pages/ReplayArchivePage"));
const ReplayDetailPage = lazy(() => import("./pages/ReplayDetailPage"));
const SeasonsPage = lazy(() => import("./pages/SeasonsPage"));
const AchievementsPage = lazy(() => import("./pages/AchievementsPage"));
const MapCareerPage = lazy(() => import("./pages/MapCareerPage"));
const HallOfFamePage = lazy(() => import("./pages/HallOfFamePage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));

function RouteFallback() {
  return (
    <div className="route-fallback" aria-live="polite">
      <img src="/brand-mark.png" alt="" />
      <span>Loading career data…</span>
    </div>
  );
}

export default function App() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const knownPath =
    pathname === "/" ||
    pathname === "/replays" ||
    /^\/replays\/[^/]+\/?$/.test(pathname) ||
    pathname === "/seasons" ||
    pathname === "/achievements" ||
    pathname === "/map-career" ||
    pathname === "/hall-of-fame" ||
    pathname === "/settings";

  useEffect(() => {
    if (!knownPath) navigate("/", { replace: true });
  }, [knownPath, navigate]);

  let page;
  if (pathname === "/") page = <DashboardPage />;
  else if (pathname === "/replays") page = <ReplayArchivePage />;
  else if (/^\/replays\/[^/]+\/?$/.test(pathname)) page = <ReplayDetailPage />;
  else if (pathname === "/seasons") page = <SeasonsPage />;
  else if (pathname === "/achievements") page = <AchievementsPage />;
  else if (pathname === "/map-career") page = <MapCareerPage />;
  else if (pathname === "/hall-of-fame") page = <HallOfFamePage />;
  else if (pathname === "/settings") page = <SettingsPage />;
  else page = <DashboardPage />;

  return (
    <Suspense fallback={<RouteFallback />}>
      <AppShell>{page}</AppShell>
    </Suspense>
  );
}
